const theme = {
  fontFamily: {
    sansSerif:
      'MuseoSans, -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Roboto, Helvetica Neue, sans-serif',
    mono: 'Menlo, Monaco, monospace',
  },
  colors: {
    primary: '#ff0033',
  },
  defaultBoxShadow: '4px 4px 10px 0 rgba(211, 211, 211, 0.75)',
  zindex: {
    overlay: 9000,
    navigationButtons: 8000,
  },
}

export default theme
